export const QUOTE_DETAIL_BASE = '/monitor/quote';
const routes = {
  root: '/',
  login: '/login',
  signup: '/signup',
  passwordReset: '/password-reset',
  monitor: '/monitor',
  shipmentDetail: '/monitor/shipment/:jobNumber',
  sharingShipmentDetail: '/share/shipment/:token',
  shipmentDetailSuccess: '/monitor/shipment/:jobNumber/success',
  releaseShipment: '/monitor/shipment/:jobNumber/release',
  editShipment: '/monitor/shipment/:jobNumber/release/edit',
  reverseShipment: '/monitor/shipment/:jobNumber/reverse',
  repeatShipment: '/monitor/shipment/:jobNumber/repeat',
  linkDeviceToJob: '/link-device-to-job',
  book: {
    newShipment: '/book/new-shipment',
    newShipmentSingle: '/book/new-shipment-single',
    newAirRetrieval: '/book/new-air-retrieval',
    frequentShipments: '/book/frequent-shipments',
    savedTemplates: '/book/saved-templates',
    addressBooks: '/book/address-books',
    shipmentHistory: '/book/shipment-history',
  },
  quoting: {
    newQuote: '/quote',
    quoteDetail: `${QUOTE_DETAIL_BASE}/:referenceNo`,
    editQuote: '/quote/:referenceNo/edit',
  },
  tools: {
    addressBookImport: '/tools/address-book-import',
    timeoutTest: '/tools/timeout-test',
  },
  reports: {
    list: '/reports',
    reportDetail: '/reports/:reportId',
  },
  admin: {
    prefix: '/admin',
    accountManagement: '/admin/account-management',
    userManagement: '/admin/user-management',
    accountDetail: {
      root: '/admin/account-management/account/:accountNumber',
      commodityTypes:
        '/admin/account-management/account/:accountNumber/commodity-types',
      temperatureDevices:
        '/admin/account-management/account/:accountNumber/temperature-devices',
      packageTypes:
        '/admin/account-management/account/:accountNumber/package-types',
      packageTemperatures:
        '/admin/account-management/account/:accountNumber/package-temperatures',
    },
    // Legacy admin console. Kept reachable by direct URL only (no UI links)
    legacy: {
      prefix: '/admin/legacy',
      userManagement: '/admin/legacy/user-management',
      userDetail: '/admin/legacy/user-management/user/:userId',
      userDetailSteps: {
        root: '/',
        documentGroup: '/document-group',
        expandedTracking: '/expanded-tracking',
      },
      addUser: '/admin/legacy/user-management/add',
      addUserSteps: {
        root: '/',
        linkAccounts: '/link-accounts',
        confirmProfile: '/confirm-profile',
        documentGroup: '/document-group',
        expandedTracking: '/expanded-tracking',
      },
      accountManagement: '/admin/legacy/account-management',
      accountDetail: {
        root: '/admin/legacy/account-management/account/:accountNumber',
        documents:
          '/admin/legacy/account-management/account/:accountNumber/documents',
        addressBookSharing:
          '/admin/legacy/account-management/account/:accountNumber/address-book-sharing',
        serviceTypes:
          '/admin/legacy/account-management/account/:accountNumber/service-types',
        commodityTypes:
          '/admin/legacy/account-management/account/:accountNumber/commodity-types',
        gpsDevices:
          '/admin/legacy/account-management/account/:accountNumber/gps-devices',
        temperatureDevices:
          '/admin/legacy/account-management/account/:accountNumber/temperature-devices',
        packageTypes:
          '/admin/legacy/account-management/account/:accountNumber/package-types',
        packageTemperatures:
          '/admin/legacy/account-management/account/:accountNumber/package-temperatures',
        userList:
          '/admin/legacy/account-management/account/:accountNumber/users',
        addUser:
          '/admin/legacy/account-management/account/:accountNumber/add-user',
        userDetail:
          '/admin/legacy/account-management/account/:accountNumber/user/:userId',
      },
      businessType: '/admin/legacy/business-profile-type',
      systemSettings: '/admin/legacy/system-settings',
    },
  },
};

export default routes;
